import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Card,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Modal,
  OutlinedInput,
  Stack,
  Typography
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { BIBlue, BIGreen, BIGrey, BIRed } from "../../assets/helpers";
import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";
import { FETCH_USERS_2, RESETPASSWORD } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { Check, Clear, Visibility, VisibilityOff } from "@mui/icons-material";
import { setShowalert } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import { useEffect } from "react";

export default function ChangePassword(props) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);

  const dispatch = useDispatch();

  const [showPassword, setShowPassword] = useState(false);
  const [showNewpassword, setShowNewpassword] = useState(false);
  const [showConfirmpassword, setShowconfirmpassword] = useState(false);

  const [currentPassword, setCurrentpassword] = useState("");
  const [newPassword, setNewpassword] = useState("");
  const [confirmPassword, setConfirmpassword] = useState("");
  const [currentPassForCompare, setCurrentPassForCompare] = useState("");

  const {
    TEXT_CHARACTERS = English?.ChangePassword?.TEXT_CHARACTERS,
    TEXT_NUMBER = English?.ChangePassword?.TEXT_NUMBER,
    TEXT_CAPITAL_LETTER = English?.ChangePassword?.TEXT_CAPITAL_LETTER,
    TEXT_LOWER_LETTER = English?.ChangePassword?.TEXT_LOWER_LETTER,
    TEXT_ENTER_CURRENT_PASSWORD = English?.ChangePassword?.TEXT_ENTER_CURRENT_PASSWORD,
    TEXT_ENTER_NEW_PASSWORD = English?.ChangePassword?.TEXT_ENTER_NEW_PASSWORD,
    TEXT_ENTER_CONFIRM_PASSWORD = English?.ChangePassword?.TEXT_ENTER_CONFIRM_PASSWORD,
    TEXT_PASSWORD_NOT_MATCH = English?.ChangePassword?.TEXT_PASSWORD_NOT_MATCH,
    TEXT_CHANGE_PASSWORD = English?.ChangePassword?.TEXT_CHANGE_PASSWORD,
    TEXT_CURRENT_PASS_LABEL = English?.ChangePassword?.TEXT_CURRENT_PASS_LABEL,
    TEXT_NEW_PASS_LABEL = English?.ChangePassword?.TEXT_NEW_PASS_LABEL,
    TEXT_PASSWORD = English?.ChangePassword?.TEXT_PASSWORD,
    TEXT_PASS_STRENGTH = English?.ChangePassword?.TEXT_PASS_STRENGTH,
    TEXT_CONFIRM_PASS_LABEL = English?.ChangePassword?.TEXT_CONFIRM_PASS_LABEL,
    TEXT_STRONG_PASS = English?.ChangePassword?.TEXT_STRONG_PASS,
    TEXT_WEAK_PASS = English?.ChangePassword?.TEXT_WEAK_PASS,
    TEXT_PASS_MATCH = English?.ChangePassword?.TEXT_PASS_MATCH,
    TEXT_PASS_NOT_MATCH = English?.ChangePassword?.TEXT_PASS_NOT_MATCH,
    TEXT_PASS_CHANGED = English?.ChangePassword?.TEXT_PASS_CHANGED
  } = multiLanguageData?.ChangePassword || {};

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickNewPassword = () => setShowNewpassword((show) => !show);
  const handleClickConfirmPassword = () => setShowconfirmpassword((show) => !show);

  // Validation conditions
  const conditions = {
    length: newPassword.length >= 6,
    number: /\d/.test(newPassword),
    capital: /[A-Z]/.test(newPassword),
    lowercase: /[a-z]/.test(newPassword)
  };

  const conditionList = [
    { condition: conditions.length, text: TEXT_CHARACTERS },
    { condition: conditions.number, text: TEXT_NUMBER },
    { condition: conditions.capital, text: TEXT_CAPITAL_LETTER },
    { condition: conditions.lowercase, text: TEXT_LOWER_LETTER }
  ];

  const onPasswordchange = (e) => {
    setCurrentpassword(e.target.value);
  };

  const onNewPasswordchange = (e) => {
    setNewpassword(e.target.value);
  };

  const onConfirmpasswordchange = (e) => {
    setConfirmpassword(e.target.value);
  };

  function isHashMatch(currenPass) {
    const hash = CryptoJS.SHA256(currenPass).toString();
    return hash === currentPassForCompare;
  }

  const validationMsg = () => {
    if (currentPassword === "") {
      let alertObj = {
        showAlert: true,
        title: "",
        text: TEXT_ENTER_CURRENT_PASSWORD
      };
      dispatch(setShowalert(alertObj));
      return false;
    }
    if (newPassword === "") {
      let alertObj = {
        showAlert: true,
        title: "",
        text: TEXT_ENTER_NEW_PASSWORD
      };
      dispatch(setShowalert(alertObj));
      return false;
    }
    if (confirmPassword === "") {
      let alertObj = {
        showAlert: true,
        title: "",
        text: TEXT_ENTER_CONFIRM_PASSWORD
      };
      dispatch(setShowalert(alertObj));
      return false;
    }
    if (newPassword !== confirmPassword) {
      let alertObj = {
        showAlert: true,
        title: "",
        text: TEXT_PASSWORD_NOT_MATCH
      };
      dispatch(setShowalert(alertObj));
      return false;
    }
    if (!isHashMatch(currentPassword)) {
      let alertObj = {
        showAlert: true,
        title: "",
        text: TEXT_PASS_NOT_MATCH
      };
      dispatch(setShowalert(alertObj));
      return false;
    } else {
      return true;
    }
  };

  const onChangepassword = async () => {
    try {
      if (validationMsg()) {
        const pwd = CryptoJS.SHA256(newPassword).toString();
        const newPasswordData = {
          Email: loginData?.userInformation?.Email,
          Password: pwd
        };
        // Email was already checked in isValidResetCode
        const getResponse = await Postrequestcall(
          RESETPASSWORD,
          newPasswordData,
          loginData?.accessToken
        );
        if (getResponse.status === 201) {
          let alertObj = {
            showAlert: true,
            title: "",
            text: TEXT_PASS_CHANGED
          };
          dispatch(setShowalert(alertObj));
          props.handleClose();
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    async function getUserPassword() {
      try {
        const userId = loginData?.userInformation?.UserId;
        const token = loginData?.accessToken;
        if (!userId || !token) {
          console.warn("Get User Data-> Missing user ID or access token.");
          return;
        }
        const obj = {
          PageNr: 1,
          NrOfRecPerPage: 20,
          FullSearch: "",
          UserId: userId,
          IncludeRecordNr: "false",
          TypeOfObjectReturned: "",
          SearchList: [
            {
              Id: userId
            }
          ],
          SortList: [
            {
              FieldName: "Id",
              Direction: "DESC"
            }
          ]
        };

        const res = await Postrequestcall(FETCH_USERS_2, obj, token);
        const password = res?.data?.data?.[0]?.password;
        if (password) {
          setCurrentPassForCompare(password);
        } else {
          console.warn("Get User Data-> Some Fields Are Missing In Response Data.");
        }
      } catch (error) {
        console.error("Get User Data-> Error Fetching User Data:", error);
      }
    }

    getUserPassword();
  }, []);

  return (
    <Modal open={props.confirmChangePasswordModal} onClose={props.handleClose}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography className="add-title">{TEXT_CHANGE_PASSWORD}</Typography>
          <Stack flexDirection={"row"} gap={1} alignItems={"center"}>
            <CloseIcon
              style={{ color: "#083DB8", cursor: "pointer" }}
              onClick={props.handleClose}
            />
            <IconButton
              disabled={currentPassword === "" || !isHashMatch(currentPassword)}
              onClick={() => onChangepassword()}>
              <SaveIcon
                style={{
                  color: currentPassword === "" || !isHashMatch(currentPassword) ? BIGrey : BIBlue,
                  cursor: "pointer"
                }}
              />
            </IconButton>
          </Stack>
        </Box>
        <Card className="pagelist-content" style={{ padding: "15px" }}>
          <FormControl fullWidth={true} variant="outlined" style={{ margin: "10px 0px" }}>
            <InputLabel htmlFor="outlined-adornment-password">{TEXT_CURRENT_PASS_LABEL}</InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label={showPassword ? "hide the password" : "display the password"}
                    onClick={handleClickShowPassword}
                    edge="end">
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              fullWidth={true}
              label={TEXT_PASSWORD}
              value={currentPassword}
              onChange={(e) => onPasswordchange(e)}
            />
          </FormControl>
          <Stack spacing={1} className="input-container">
            <Stack direction="row" alignItems="center">
              {isHashMatch(currentPassword) || currentPassword === "" ? (
                <>
                  <Check
                    style={{ color: currentPassword !== "" ? BIGreen : BIGrey }}
                    className="icon-position"
                  />
                  <Typography
                    variant="body2"
                    style={{ color: currentPassword !== "" ? BIGreen : BIGrey }}>
                    {TEXT_CURRENT_PASS_LABEL}
                  </Typography>
                </>
              ) : (
                <>
                  <Clear style={{ color: BIRed }} className="icon-position" />
                  <Typography variant="body2" style={{ color: BIRed }}>
                    {TEXT_CURRENT_PASS_LABEL}
                  </Typography>
                </>
              )}
            </Stack>
          </Stack>
          <FormControl fullWidth={true} variant="outlined" style={{ margin: "10px 0px" }}>
            <InputLabel htmlFor="outlined-adornment-password">{TEXT_NEW_PASS_LABEL}</InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showNewpassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label={showNewpassword ? "hide the password" : "display the password"}
                    onClick={handleClickNewPassword}
                    edge="end">
                    {showNewpassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              fullWidth={true}
              label={TEXT_PASSWORD}
              value={newPassword}
              onChange={(e) => onNewPasswordchange(e)}
            />
          </FormControl>
          <Box mt={2}>
            <Typography
              sx={{ display: "flex", justifyContent: "space-between" }}
              variant="body1"
              gutterBottom>
              <b>{TEXT_PASS_STRENGTH}</b>
              <span
                style={{
                  color: Object.values(conditions).every((val) => val) ? BIGreen : BIRed
                }}>
                {Object.values(conditions).every((val) => val) ? TEXT_STRONG_PASS : TEXT_WEAK_PASS}
              </span>
            </Typography>
            <Box
              sx={{
                backgroundColor: "#e0e0e0",
                height: 6,
                borderRadius: 3,
                overflow: "hidden",
                mb: 2
              }}>
              <Box
                sx={{
                  backgroundColor: Object.values(conditions).every((val) => val) ? BIGreen : BIRed,
                  width: `${Object.values(conditions).filter((val) => val).length * 25}%`,
                  height: "100%"
                }}
              />
            </Box>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {conditionList.map(({ condition, text }, index) => {
                const color = newPassword.length === 0 ? BIGrey : condition ? BIGreen : BIRed;
                const Icon = condition || newPassword.length === 0 ? Check : Clear;

                return (
                  <li key={index} style={{ color, display: "flex", alignItems: "center" }}>
                    <Icon /> <span style={{ marginLeft: 8 }}>{text}</span>
                  </li>
                );
              })}
            </ul>
          </Box>
          <FormControl fullWidth={true} variant="outlined" style={{ margin: "10px 0px" }}>
            <InputLabel htmlFor="outlined-adornment-password">{TEXT_CONFIRM_PASS_LABEL}</InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showConfirmpassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label={showConfirmpassword ? "hide the password" : "display the password"}
                    onClick={handleClickConfirmPassword}
                    edge="end">
                    {showConfirmpassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              fullWidth={true}
              label={TEXT_PASSWORD}
              value={confirmPassword}
              onChange={(e) => onConfirmpasswordchange(e)}
            />
          </FormControl>
          <Stack spacing={1} className="input-container">
            <Stack direction="row" alignItems="center">
              {(newPassword === confirmPassword && newPassword !== "") || confirmPassword === "" ? (
                <>
                  <Check
                    style={{
                      color:
                        newPassword === confirmPassword && newPassword && confirmPassword
                          ? BIGreen
                          : BIGrey
                    }}
                    className="icon-position"
                  />
                  <Typography
                    variant="body2"
                    style={{
                      color:
                        newPassword === confirmPassword && newPassword && confirmPassword
                          ? BIGreen
                          : BIGrey
                    }}>
                    {TEXT_PASS_MATCH}
                  </Typography>
                </>
              ) : (
                <>
                  <Clear style={{ color: BIRed }} className="icon-position" />
                  <Typography variant="body2" style={{ color: BIRed }}>
                    {TEXT_PASS_MATCH}
                  </Typography>
                </>
              )}
            </Stack>
          </Stack>
        </Card>
      </Box>
    </Modal>
  );
}
